export default "__VITE_ASSET__CPicm_bn__"